import React, { useMemo, useState } from "react";
import Calendar from "../../components/Calendar";
import { CalendarioWrap } from "./styles";
import { VOCAB_CALENDARIO, buildEventosPendentes, buildEventosRealizados } from "./visoes";

/**
 * Pendentes no dia do limite das máquinas (tom do status do lote) e, com o
 * seletor "Realizados" ligado, cada corte/bordo/furação no dia em que foi
 * feito (tom neutro — mesmo padrão dos "Carregado" do Planejamento de Entregas).
 */
export default function CalendarioView({
  lotes,
  dados,
  filters,
  realizados,
  escala,
  onEscalaChange,
  onSelectLoteId,
}) {
  const [cursor, setCursor] = useState(() => new Date());

  const eventosPendentes = useMemo(() => buildEventosPendentes(lotes), [lotes]);
  const eventosRealizados = useMemo(
    () => (realizados ? buildEventosRealizados(dados, filters) : []),
    [realizados, dados, filters]
  );
  const eventos = useMemo(
    () => [...eventosPendentes, ...eventosRealizados],
    [eventosPendentes, eventosRealizados]
  );

  return (
    <CalendarioWrap data-pdf="calendario-industrializacao">
      <Calendar
        events={eventos}
        cursor={cursor}
        scale={escala}
        onCursorChange={setCursor}
        onScaleChange={onEscalaChange}
        onSelectEvent={(ev) => onSelectLoteId(ev.payload.loteId)}
        emptyMessage="Nenhum ambiente nas máquinas no período com os filtros atuais."
        vocab={VOCAB_CALENDARIO}
      />
    </CalendarioWrap>
  );
}
